export default __webpack_public_path__ + "static/media/atlantica_transparent.19b20721.png";